import { useState } from 'react';
import { connect } from 'react-redux';
import { acceptOrder } from 'actions/orderAccept';
import { resetOrder } from 'actions/orderSearch';

let _content = null;

const OrderAcceptComplete = (props) => {
  const { resetOrder, acceptOrder, currentStaff, order } = props;

  const [redirect, setRedirect] = useState(false);
  const [successModal, setSuccessModal] = useState(true);

  const acceptOrderData = () => {
    const requestBody = {
      staff_remote_id: currentStaff.remote_id,
      retailer_remote_id: currentStaff.current_store.remote_id,
    };
    acceptOrder(order.pk, requestBody);
  };

  const cleanStateAndRedirect = () => {
    resetOrder();
    setRedirect(true);
  };

  const closeModal = () => {
    setSuccessModal(false);
    setRedirect(true);
  };

  const printPage = () => {
    window.print();
  };

  return (
    _content &&
    _content({
      props,
      redirect,
      successModal,
      acceptOrderData,
      cleanStateAndRedirect,
      closeModal,
      printPage,
    })
  );
};

const mapDispatchToProps = {
  resetOrder,
  acceptOrder,
};

const mapStateToProps = (state) => ({
  order: state.orderSearch.order,
  error: state.orderAccept.error,
  pending: state.orderAccept.pending,
  currentStaff: state.staffs.currentStaff,
  success: state.orderAccept.success,
});

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(OrderAcceptComplete);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/orders/acceptComplete/index.js